import React from "react";
import styled from "styled-components";
import logoTitle from '../../../image/logoTitle.png';

// 이미지 로드 실패 시 디폴트 이미지로 대체
const handleImageError = (e) => {
  e.target.src = logoTitle;
};

// 코치 프로필 이미지 렌더링 //
function CoachProfileImages({ teacherProfile, teacherProfiles }) {
  // 단일 프로필인 경우
  if (!teacherProfiles || teacherProfiles.length <= 1) {
    return (
      <CoachImage
        src={teacherProfile || logoTitle}
        alt="coach profile"
        onError={handleImageError}
      />
    );
  }

  // 여러 프로필인 경우 (2명 이상)
  const profileCount = teacherProfiles.length;

  return (
    <CoachImageGrid>
      {/* 왼쪽 위 (0,0) - 항상 표시 */}
      <TopLeftItem>
        <CoachImageSmall src={teacherProfiles[0] || logoTitle} alt="coach 1" onError={handleImageError} />
      </TopLeftItem>

      {/* 오른쪽 위 (0,1) - 3명 이상일 때 */}
      {profileCount >= 3 && (
        <TopRightItem>
          <CoachImageSmall src={teacherProfiles[1] || logoTitle} alt="coach 2" onError={handleImageError} />
        </TopRightItem>
      )}

      {/* 왼쪽 아래 (1,0) - 3명 이상일 때 */}
      {profileCount >= 3 && (
        <BottomLeftItem>
          <CoachImageSmall src={teacherProfiles[2] || logoTitle} alt="coach 3" onError={handleImageError} />
        </BottomLeftItem>
      )}

      {/* 오른쪽 아래 (1,1) - 2명일 때 또는 4명 이상일 때 */}
      {(profileCount === 2 || profileCount >= 4) && (
        <BottomRightItem>
          <CoachImageSmall
            src={teacherProfiles[profileCount === 2 ? 1 : 3] || logoTitle}
            alt="coach 4"
            onError={handleImageError}
          />
        </BottomRightItem>
      )}
    </CoachImageGrid>
  );
}

export default React.memo(CoachProfileImages);

const CoachImage = styled.img`
  width: 31px;
  height: 31px;

  border-radius: 0 0 0 5px;

  object-fit: cover;
`;

const CoachImageGrid = styled.div`
  display: grid;
  grid-template-columns: 15.5px 15.5px;
  grid-template-rows: 15.5px 15.5px;
  width: 31px;
  height: 31px;
  position: relative;
`;

const CoachImageGridItemBase = styled.div`
  width: 15.5px;
  height: 15.5px;
  overflow: hidden;
`;

const TopLeftItem = styled(CoachImageGridItemBase)`
  grid-column: 1;
  grid-row: 1;
`;

const TopRightItem = styled(CoachImageGridItemBase)`
  grid-column: 2;
  grid-row: 1;
`;

const BottomLeftItem = styled(CoachImageGridItemBase)`
  grid-column: 1;
  grid-row: 2;
  border-radius: 0 0 0 5px;
`;

const BottomRightItem = styled(CoachImageGridItemBase)`
  grid-column: 2;
  grid-row: 2;
`;

const CoachImageSmall = styled.img`
  width: 15.5px;
  height: 15.5px;
  object-fit: cover;
`;
